var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticStyle: {
      "width": "90%",
      "margin": "0 5%",
      "margin-top": "20px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "height": "30px",
      "width": "25%"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.staff_name))])], 1)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("性别：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.staff_gender_title))])], 1)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("身份证号：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.staff_card))])], 1)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("出生日期：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.birth_date))])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("年龄：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.age))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.staff_telephone))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("民族：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.nation))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("籍贯：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.native_place))])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("身份证地址：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.card_address))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("现居住地地址：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.residence))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("户口所在地：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.domicile_place))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("户籍性质：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.household_register))])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("银行卡号：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.bank_no))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("第一学历：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.first_degree))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("最高学历：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.second_degree))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("健康状况：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.health))])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("邮箱：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.mailbox))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("微信：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.we_chat))])], 1)], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])])])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dca9d05","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Ygxxlb/tabs/basic.vue
// module id = null
// module chunks = 